import React from 'react';
import PropTypes from 'prop-types';

import {
  BREEDER_CENTER_PATH,
  BREEDER_DASHBOARD_PATH,
  BREEDER_EDIT_PROFILE_PATH,
  BREEDER_SETTINGS_ACCOUNT_PATH,
  BREEDER_DOWNLOADS_PATH,
  HELP_CENTER_BREEDERS_PATH
} from 'dpl/shared/constants/urls';
import {
  FancyDropdownMenuItem
} from 'dpl/components/FancyDropdown';
import NotificationCount from 'dpl/common/components/NotificationCount';
import SmartLink from 'dpl/components/SmartLink';

export default function UserHeaderLoggedInBreederMenu({
  totalNotificationsCount, profilePath, isPublished
}) {
  return (
    <>
      <FancyDropdownMenuItem itemKey="dashboard">
        <SmartLink
          to={ BREEDER_DASHBOARD_PATH }
          className="flex w-100 align-items-center pv2 ph4"
        >
          <span className="flex-auto">Dashboard</span>
          { Boolean(totalNotificationsCount) && (
            <NotificationCount className="ml2" count={ totalNotificationsCount } />
          ) }
        </SmartLink>
      </FancyDropdownMenuItem>
      <FancyDropdownMenuItem itemKey="edit">
        <SmartLink
          to={ BREEDER_EDIT_PROFILE_PATH }
          className="w-100 db pv2 ph4"
        >
          Edit profile
        </SmartLink>
      </FancyDropdownMenuItem>
      <FancyDropdownMenuItem itemKey="view">
        <a href={ profilePath } className="w-100 db pv2 ph4">
          View profile
        </a>
      </FancyDropdownMenuItem>
      <FancyDropdownMenuItem itemKey="settings">
        <SmartLink
          to={ BREEDER_SETTINGS_ACCOUNT_PATH }
          className="w-100 db pv2 ph4"
        >
          Settings
        </SmartLink>
      </FancyDropdownMenuItem>
      {
        isPublished && (
          <FancyDropdownMenuItem itemKey="downloads">
            <SmartLink
              to={ BREEDER_DOWNLOADS_PATH }
              className="w-100 db pv2 ph4"
            >
              Downloads
            </SmartLink>
          </FancyDropdownMenuItem>
        )
      }
      <FancyDropdownMenuItem itemKey="breeder-center">
        <a href={ BREEDER_CENTER_PATH } className="w-100 db pv2 ph4 nowrap">
          Good Breeder Center
        </a>
      </FancyDropdownMenuItem>
      <FancyDropdownMenuItem itemKey="help_breeders">
        <a href={ HELP_CENTER_BREEDERS_PATH } className="w-100 db pv2 ph4">
          Help
        </a>
      </FancyDropdownMenuItem>
    </>
  );
}

UserHeaderLoggedInBreederMenu.propTypes = {
  profilePath: PropTypes.string.isRequired,
  isPublished: PropTypes.bool.isRequired,
  totalNotificationsCount: PropTypes.number.isRequired
};
